import { render, staticRenderFns } from "./BetslipTabs.vue?vue&type=template&id=58fc0b15&"
import script from "./BetslipTabs.vue?vue&type=script&lang=js&"
export * from "./BetslipTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports